<template lang="pug">
  .lockable-input
    input.input.lockable-input__input(
    disabled="true"
    v-model="value"
    )
    button.lockable-input__button.button.button_square(
    @click.prevent="$emit('on-button-click')"
    )
      img(src="@/assets/images/icons/icon-edit.svg")
</template>

<script>

export default {
  name: "LockableInput",
  props: {
    value: {
      type: [String, Number],
      default: ""
    }
  }

};
</script>
